import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AiTwotoneDelete } from 'react-icons/ai';
import { client, urlFor } from '../client';
import { fetchUser } from '../utils/FetchUser';
import { useAlert } from 'react-alert';

const Conversation = ({ conversation }) => {
    const [postHovered, setPostHovered] = useState(false);
    const navigate = useNavigate();
    const { postedBy, body, _id, title, familyName } = conversation;
    const user = fetchUser();
    const alert = useAlert();

    const deleteConversation = (id) => {
        client
            .delete(id)
            .then(() => {
                window.location.reload();
            });
    };

    return (
        <div className="m-2 p-1 bg-secondaryColor rounded-lg">
            <div className='flex justify-between'>
                <Link to={`/user-profile/${postedBy?._id}`} className="flex gap-2 mt-2 items-center p-1">
                    <img
                        className="w-8 h-8 rounded-full object-cover"
                        src={postedBy?.profUrl}
                        alt="user-profile"
                    />
                    <p className="font-semibold capitalize">{postedBy?.userName}</p>
                </Link>
                <p className='flex items-center text-xs mt-2 p-1'>{familyName[0] ? familyName[0] : ""}</p>

            </div>
            <div className="w-auto bg-white rounded-lg flex justify-center flex-col border-2">
                <div
                    onMouseEnter={() => setPostHovered(true)}
                    onMouseLeave={() => setPostHovered(false)}
                    onClick={() => navigate(`/conversation-detail/${_id}`)}
                    className=" relative cursor-zoom-in w-auto hover:shadow-lg rounded-lg overflow-hidden transition-all duration-500 ease-in-out"
                >
                    <div className='content-start'>
                        <a className="flex gap-2 mt-2 items-center justify-center">
                            <span className="font-semibold items-center flex justify-center" >
                                {title}
                            </span>
                        </a>
                        <p className='p-2'>
                            {body}
                        </p>
                    </div>
                    {postHovered && (
                        <div
                            className="absolute top-0 w-full h-full flex flex-col justify-between p-1 pr-2 pt-2 pb-2 z-50"
                            style={{ height: '100%' }}
                        >
                            <div className=" flex justify-end items-center gap-2 w-full">
                                {
                                    postedBy?._id === user?.sub && (
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                alert.show(
                                                    <div style={{ color: 'white' }}>
                                                        Confirm deletion of post?
                                                        <div className='justify-center'>
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    deleteConversation(_id);
                                                                }}
                                                                className="bg-indigo-500 text-white font-bold p-2 rounded-full w-20 outline-none justify-center"
                                                            >
                                                                Confirm
                                                            </button>
                                                        </div>
                                                    </div>);
                                                // deleteConversation(_id);
                                            }}
                                            className="bg-white p-2 rounded-full w-8 h-8 flex items-center justify-center text-dark opacity-75 hover:opacity-100 outline-none"
                                        >
                                            <AiTwotoneDelete />
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Conversation;

